import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Hidden,
  IconButton,
  Dialog,
  Card,
} from "@material-ui/core";
import QuickPayInformation from "./view/_information";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import { useSelector } from "react-redux";
import { adminService } from "../../../services/index";
import AccountBalance from "./view/_account-input";
import HelpIcon from "@material-ui/icons/Help";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { commonService } from "../../../services/common.service";
import { Skeleton } from "@material-ui/lab";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  colorWhite: {color: theme.palette.ePrimary.base + " !important"},
  blueCard: {
    background: theme.palette.ePastelColor2.base + " !important",
    padding: "0rem 0.625rem",
  },
  viewBalanceTitle: {
    fontWeight: "600",
    color: theme.palette.ePrimary.base + " !important"
  },
  helpIcon: {
    color: theme.palette.ePastelColor2.base + " !important",
  },
  imgStyle: {
    width: "70%",
  },
  subtitleColor: {
    color: theme.palette.eRich.base,
  },
  smallImg: {
    width: "70%",
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.eLight.base,
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
export default function QuickPayContent() {
  const {t:content, ready: contentReady} = useTranslation(
    "content-E_AUTH_QUICK_PAY"
  );

  let classes = useStyles();
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 550px)" });
  let languageCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  // let labels = useSelector(
  //   (store) => store?.labels?.data?.getLabels?.E_QUICK_PAY
  // );
  const {t:labels,ready:labelsready}=useTranslation("label-E_QUICK_PAY")
  let quickPayAccount = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.QUICK_PAY_ACCOUNT_BALANCE_IMAGE
  );
  let [openDialog, setOpenDialog] = useState(false);
  let [accountBalanceImg, setAccountBalance] = useState();
  useEffect(() => {
    (async () => {
      if (quickPayAccount) {
        await commonService.getAssestUrl(quickPayAccount).then((res) => {
          setAccountBalance(res);
        });
      }
    })();
  }, [quickPayAccount]);

  const handleClose = () => {
    setOpenDialog(false);
  };
  const handleClickOpen = () => {
    setOpenDialog(true);
  };
  return (
    <>
      {accountBalanceImg ? (
        <Grid container spacing={2}>
          <Grid item xs={12} md={7}>
            <Grid container spacing={6}>
              <Grid item>
                <Grid container spacing={4}>
                  <Grid item>
                  <Hidden  xsDown>
                    <Typography variant="subtitle2"
                      className={classes.subtitleColor}
                    > {contentReady ? content("E_QUICK_PAY_SUBTITLE").answer : ""}</Typography> 
                  </Hidden>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Grid container direction="row" justify="space-between">
                      <Grid item>
                        <Typography variant="subtitle1" className={classes.viewBalanceTitle}>
                        {labels("E_QUICK_PAY_VIEW_ACCOUNT_BALANCE_TITLE")}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Hidden smUp>
                          <HelpIcon
                            className={classes.helpIcon}
                            onClick={handleClickOpen}
                          />
                        </Hidden>
                      </Grid>
                    </Grid>
                    <AccountBalance  />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <img
                      src={accountBalanceImg?.assetPath}
                      alt={labels([accountBalanceImg?.fallBackLabelKey])}
                      className={
                        isTabletOrMobile ? classes.imgStyle : classes.smallImg
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid item>
                <Typography
                  variant="subtitle2"
                  className={classes.subtitleColor}
                  dangerouslySetInnerHTML={{
                    __html: contentReady ? content("E_QUICK_PAY_LAST_PARAGRAPH").answer : "",
                  }}
                ></Typography>
              </Grid> */}
            </Grid>
          </Grid>

          <Hidden xsDown>
            <Grid item xs={12} md={5}>
                <Card className={classes?.blueCard}>
                  <QuickPayInformation  />
                </Card>
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Dialog
              onClose={handleClose}
              aria-labelledby="customized-dialog-title"
              open={openDialog}
            >
              <DialogTitle
                id="customized-dialog-title"
                onClose={handleClose}
                className={classes.blueCard}
              >
                <Typography className={classes.colorWhite} variant="h6">
                {labels("E_QUICK_PAY_ABOUT_YOUR_ACCOUNT_TITLE")}
                </Typography>
              </DialogTitle>
              <MuiDialogContent className={classes.blueCard}>
               <QuickPayInformation  />
              </MuiDialogContent>
            </Dialog>
          </Hidden>
        </Grid>
      ) : (
        <>
        </>
      )}
    </>
  );
}
